import React from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { CloseToOrAward, getAwardTitles, useTrack } from '../../api';
import { Text } from '../common/Text';
import AwardIcon from './AwardIcon';

interface Props {
  award: CloseToOrAward;
  hideSubtitle?: boolean;
  compact?: boolean;
}

const SubTitle = styled(Text)`
  font-size: 9px;
  color: white;
  text-shadow: 0px 3px 10px #0000005a;
  text-align: center;
  line-height: 1.5;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h3`
  margin: 0;
  margin-bottom: 6px;
  font-size: 12px;
  text-shadow: 0px 3px 10px #0000005a;
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2px;
`;

const CardBox = styled.div<{
  compact: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  width: ${(p) => (p.compact ? 210 : 134)}px;
  height: ${(p) => (p.compact ? 75 : 160)}px;
  border: 5px solid black;
  color: white;
  background: transparent linear-gradient(2deg, #1d1d1d 0%, #535353 100%) 0% 0%
    no-repeat padding-box;

  ${AwardIcon} {
    height: 70px;
  }

  ${Container} {
    flex-direction: ${(p) => (p.compact ? 'row' : 'column')};
  }

  ${({ compact }) =>
    compact &&
    `
  ${AwardIcon} {
    padding-top: 0px !important;
    height: 55px;
    width: auto;
  }
  
  ${Title} {
    margin-bottom: 0px;
    color: white;
  }

  ${SubTitle} {
    margin-bottom: 0px;
    margin-top: 6px;
    color: white;
  }

  ${Content} {
    width: 100%;
    align-items: flex-start;
    padding-left: 10px;
    justify-content: flex-start;
    height: 100%;
    padding-top: 6px;
  }

  ${Container} {
    padding-left: 6px;
  }
  `}
`;

const Card = ({ award, hideSubtitle = false, compact = false }: Props) => {
  const [track] = useTrack(award.track_id);
  const { title, subTitle } = getAwardTitles(award);
  const { t } = useTranslation('awards');
  return (
    <CardBox compact={compact}>
      <Container>
        <AwardIcon type={award.type} />
        <Content>
          <Title>{t(title)}</Title>
          {compact ? (
            !hideSubtitle &&
            subTitle && (
              <SubTitle>
                {`"${track?.title ? `${track?.title} ` : ``}${
                  t(subTitle) as string
                }"`}
              </SubTitle>
            )
          ) : (
            <SubTitle>
              {!hideSubtitle && subTitle
                ? `"${track?.title ? `${track?.title} ` : ``}${
                    t(subTitle) as string
                  }"`
                : ' '}
            </SubTitle>
          )}
        </Content>
      </Container>
    </CardBox>
  );
};

export default Card;
